import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { MessageTemplate } from "@idw-types/data/message-template";

type GetMessageTemplatesRequestResponse = {
    selfServiceVerificationMessageTemplates: Array<MessageTemplate>;
};

export const getMessageTemplatesRequest = async (): Promise<{ data: GetMessageTemplatesRequestResponse, error: any }> => {
    const route = apiRoutes.axnadminCore.data.messageTemplate;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};